module.exports = __webpack_public_path__ + "assets/forward.svg?2a4bc212c6a7d7434e72d492df651eaa";